import React from 'react'

/**
 * External dependencies
 */
import clickOutside from 'react-click-outside';
import { flowRight } from 'lodash';

/**
 * Internal dependencies
 */
// import withFocusReturn from '../higher-order/with-focus-return';

class PopoverDetectOutside extends React.Component {
	handleClickOutside( event ) {
		const { onClickOutside } = this.props;
		if ( onClickOutside ) {
			onClickOutside( event );
		}
	}

	render() {
		return this.props.children;
	}
}

export default flowRight( [
	// withFocusReturn,
	clickOutside,
] )( PopoverDetectOutside );



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/popover/detect-outside.js